<template>
  <div>
    <div class="page-header"><h2>数据概览</h2></div>
    <el-empty description="数据概览内容已迁移至首页" />
  </div>
</template>
<script setup>
</script>
<style scoped>

</style>
